const DEFAULT_TRIP_SECTION = 'discovery';

export const getLastSectionStorageKey = (tripId: string): string =>
  `trip-open-view:last-section:${tripId}`;

export const getLastTripSection = (
  tripId: string,
  fallback: string = DEFAULT_TRIP_SECTION
): string => {
  return localStorage.getItem(getLastSectionStorageKey(tripId)) || fallback;
};
